export default __webpack_public_path__ + "static/media/obsidian dream.dd6bca31.jpg";